import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class DomainEndpoint extends BaseEndpoint {}
